import React from "react";

import Heading from "components/heading";
import HeroSection from "components/hero-section";
import { sendAnalyticEvent } from "components/layout/page/use-page";
import Link from "next/link";

import { ChevronDoubleRightIcon } from "@heroicons/react/outline";

const PartnerWithEnerflo = () => (
  <div className="bg-primary z-20 relative">
    <HeroSection className="sm:py-12 lg:py-16">
      <HeroSection.Content>
        <div className="flex flex-col flex-wrap items-center justify-center gap-2 -mx-2 -my-2 text-white text-center">
          <Heading tag="h3" className="mb-2">
            Partner with Enerflo
          </Heading>
          <div className="text-base md:text-lg mx-2 my-2 max-w-lg">
            Interested in integrating with Enerflo? Talk to the Enerflo Business Development team to get started.
          </div>
          <Link href="/about/contact">
            <a
              className="btn btn-dark text-sm md:text-base flex items-center whitespace-nowrap mx-2 my-2"
              onClick={() => sendAnalyticEvent("Engagement Button", "Buttons", "Partner with Enerflo")}
            >
              <span>Contact Enerflo</span>
              <ChevronDoubleRightIcon className="h-4 w-4 ml-2" />
            </a>
          </Link>
        </div>
      </HeroSection.Content>
    </HeroSection>
  </div>
);

export default PartnerWithEnerflo;
